module.exports = __webpack_public_path__ + "img/way_e.9a09aa10.jpg";